<template>
  <div class="root">
    <header>Terms of Service</header>
    <div>1. Your Relationship with Us</div>

    <p>
      Welcome to Haba (the "Platform") provided by HABAGOGO LIMITED, whose registered office is located at UNIT E01, 10/F, WONG KING IND, BUILDING, 2-4 , TAI YAU STREET, SAN PO KONG, HONG KONG (such entities are collectively referred to as "Haba", "We" or "Us").
    </p>

    <p>
      You are reading the terms of service (the "Terms"), which govern your
      relationship with us and act as an agreement between you and us, and
      clarify your access to and use of the platform and our related websites,
      services, applications, products and content (collectively, the
      "Services").Access to certain services or service features (for example,
      but not limited to, the ability to submit or share user content (as
      defined below)) may be limitedby ageand does not apply to all service
      users.The services we provide are for private and not commercial use
      only.For purposes of these terms, "You" and "Your" refer to your identity
      as a user of the services.
    </p>
    <p>
      These terms constitute a legally binding agreement between you and
      us.Please read them carefully.
    </p>
    <div>2.Acceptance Term</div>
    <p>
      By accessing or using our services, you confirm that you can enter into a
      binding contract with us and that you accept and agree to abide by these
      terms.
    </p>
    <p>
      Your access to and use of our services is also governed by our
      <router-link to="/community">Community Guidelines</router-link>
      and
      <router-link to="/virtual">Virtual Items Policy</router-link>
      , the terms of which can be found directly on the platform.These
      additional guidelines and policies have been incorporated by reference
      into the legally binding contract between you and us.
  
    </p>
    <p>
      Theplatform and our services are not applicable to children.Children are
      not allowed to use the services of theplatform for any purpose. If you, as
      a guardian, find that a child under your guardianship has used
      ourplatform, please contact us immediatelyto delete it.Children refer to
      users under the age of 13; or if the user isfrom thecountry/arealisted in
      the table below, the relevant age for that country/area is listed.
    </p>
    <table>
      <tr>
        <th>Country/area that the user is from</th>
        <th>Minimum age of the user</th>
      </tr>
      <tr>
        <td>European Economic Area/Switzerland/UK</td>
        <td>16*</td>
      </tr>
      <tr>
        <td>India</td>
        <td>18*</td>
      </tr>
      <tr>
        <td>Saudi Arabia</td>
        <td>15</td>
      </tr>

      <tr>
        <td>Brazil</td>
        <td>18</td>
      </tr>
      <tr>
        <td>Saudi Arabia</td>
        <td>15</td>
      </tr>
      <tr>
        <td>USA</td>
        <td>16</td>
      </tr>
      <tr>
        <td>Malaysia</td>
        <td>18</td>
      </tr>
      <tr>
        <td>Russia</td>
        <td>14</td>
      </tr>
      <tr>
        <td>Singapore</td>
        <td>18</td>
      </tr>
      <tr>
        <td>Thailand</td>
        <td>20*</td>
      </tr>
      <tr>
        <td>Turkey</td>
        <td>18*</td>
      </tr>
      <tr>
        <td>Egypt</td>
        <td>18*</td>
      </tr>
      <tr>
        <td>Indonesia</td>
        <td>21</td>
      </tr>
      <tr>
        <td>The United Arab Emirates</td>
        <td>21***</td>
      </tr>
    </table>
    <p>
      *Users under the minimum age in that country/area must obtain consent from
      their parents/guardians before using the platform.
    </p>
    <p>
      **Users in the European Economic Area, the UK and Switzerland under the
      age of 16 can use the platform provided they obtain the consent from their
      parents/guardians prior to using the platform.
    </p>
    <p>
      ***For users located in the United Arab Emirates, the minimum age to be
      legally consented to commercial transactions is 21 (according to the
      Moslem calendar).However, the underage user between the ages of 18 and 21
      may obtain a court order allowing him/her to enter into specific
      commercial transactions.In addition, the underage user over the age of 7
      can engage in commercial transactions with the approval of their
      guardians.
    </p>
    <p>
      Please also read our
      <router-link to="/privacy">Privacy Policy</router-link>
      ,as this determines how we use your personal information.Your use of the
      services on our platform is deemed to be your acceptance of the terms.
    </p>
    <p>
      You shall print or retain a local copy of these terms for recording
      purposes.
    </p>

    <div>3. Zero Tolerance for Objectionable Content and Abusive Users</div>
     <p>Haba has zero tolerance for objectionable content or abusive users. Users must not create, upload, publish, send, share, display, or otherwise make available any objectionable content, or engage in abusive behavior toward other users.</p>
      <p>Users may report objectionable content, inappropriate behavior, or abusive users directly within the Haba app. Users may also block abusive users using the blocking tools provided in the app.</p>
      <p>Haba will review all reports of objectionable content or abusive behavior within 24 hours of receiving the report. If we confirm that a violation has occurred, we will remove the offending content and suspend or permanently ban the user who provided or published it.</p>
      <p>Users may use the reporting tools available within the Haba app or contact us at to report objectionable content, abusive behavior, or other safety concerns.</p>


    <div>4.Changes to Terms and Services</div>
    <p>
      We may amend these terms from time to time, and we will use commercially
      reasonable efforts to give all users reasonable notice of any material
      changes to these terms, such as through notices on our platform, but you
      should also read the terms at regular intervals to check for such
      changes.We will also update the "last update" at the top of these terms to
      reflect the effective date of such terms.Your continued use of the
      services beyond the effective date of the new terms will indicate your
      acceptance of the new terms after we have fulfilled our obligations as
      informed.If you do not agree to the new terms, you must stop accessing or
      using the services.
    </p>
    <div>5.Your Account</div>
    <p>
      To access and use certain content of this software, you may need to create
      an account with us ("Your Account").
    </p>
    <p>
      Your account is your personal account and you are prohibited from giving,
      lending, transferring or otherwise allowing any other person to access or
      use your account.Your user identifiers (such as user ID) assignedby the
      platform in our services remain our property and we have the right to
      disable, recycle and reuse these identifiers once you or we terminate or
      deactivate your account for any reason.
    </p>
    <p>
      You are responsible for: (I) protecting the information of your account,
      including any password used to access your account and our services, and
      (ii) using our services under your account.If you know or suspect that
      your account or password has been compromised, you should promptly notify
      us via report@habagogo.com Unless we receive and confirm notification
      from you that your account and/or its password has been compromised, we
      will consider you to be using your account.
    </p>
    <p>
      You agree to be solely responsible (to us and others) for activities that
      occur under your account.
    </p>
    <p>
      We reserve the right to disable your user account at any time, including
      your failure to comply with any provision of these terms under our
      reasonable advice, or your activity in our discretion, will or may cause
      harm, damage, violation or infringement of any third party rights, or
      violation of any applicable laws or regulations.
    </p>
    <div>6.Content</div>
    <p>
      When you submit, upload, transmit or display any data, information, media
      or other content related to your use of our services ("Your Content"), you
      understand and agree that
    </p>
    <p>·You will continue to own and be responsible for your content;</p>
    <p>·Our use of your content will be governed by our Privacy Policy;</p>
    <p>
      ·You grant us and our affiliates the right to use your content (at no cost
      to you), including the right to create derivative works of your content
      for the following purposes, to publicly display and publicly perform your
      content, and to promote, develop and attempt to improve our
      services,including our services related to your submission and any other
      services we may provide now or in the future;
    </p>
    <p>
      ·You acknowledge and agree that we may receive revenue, increase goodwill
      or otherwise increase our value as a result of your use of the services,
      and that you are not entitled to share in any such revenue, goodwill or
      any value unlessexpressly provided in another agreement between you and
      us.You further confirm that, unless expressly permitted by us in these
      terms or in another agreement you enter into with us, you (i) are not
      entitled to receive any revenue or other remuneration from the services,
      including any user content you create; and (ii)are prohibited from
      exercising any right to profit from any user content within the services
      or from any third party or to obtain party services at a relative value;
    </p>
    <p>
      ·When using your content for these purposes, we and our affiliates may
      copy, mandate, store, process, adapt, modify, translate, execute,
      distribute and publish your content, including distribution methods
      developed in the future, provided they are incorporated into our services
      you use;
    </p>
    <p>
      ·We may share your content with third parties of our partners who help
      provide, promote, develop and improve our services, but we will not sell
      your content to such third parties (other than our affiliates) for their
      own purposes (i.e. for any purpose unrelated to our services);
    </p>
    <p>
      ·You will comply with the instructions and these terms when submitting
      content.
    </p>
    <p>
      You are fully responsible for the content and we recommend that you keep a
      backup copy of it at all times.You must at all times ensure that: (i) you
      have the rights necessary to submit, transmit or display your content and
      grant us the rights set out in these terms;(ii) your content (and our use
      of your content in accordance with these terms) does not infringe or
      violate the rights of anyone or otherwise violate any applicable law or
      regulation.
    </p>
    <p>
      You warrant that any such contributions meet these criteria and that you
      will be liable to us and indemnify us for any breach of this warranty.This
      means that you will be liable for any loss or damage arising from a breach
      of the warranty.
    </p>
    <p>
      We reserve the right to block or remove your content for any reason,
      including content we deem appropriate or required by applicable laws and
      regulations.
    </p>
    <p>
      In certain circumstances, we also have the right to disclose your identity
      to any third party who claims that user content you post or upload to our
      services constitutes a violation of their intellectual property rights or
      privacy rights.Disclosure will be subject to a legally binding court
      order.
    </p>
    <div>7.Prohibited Activities</div>
    <p>
      You agree not to engage in any of the following prohibited activities in
      connection with or related to our services, or to allow anyone to do the
      same on our services using your account.
    </p>
    <p>
      ·Impersonate any person or misrepresent your affiliation with any person
      or entity when registering an account (including by creating a false
      account name or accessing another user's account) or using our services
      for any communication or sharing or posting any content or information;
    </p>
    <p>
      ·Use or attempt to use other users' accounts, services or systems without
      our authorization, or create false identities on the services;
    </p>
    <p>
      ·Infringe intellectual property or other rights of third parties through
      your account name;
    </p>
    <p>
      ·Copy, modify, adapt, translate, conduct reverse engineering of,
      disassemble and decompilate unauthorized content to the fullest extent
      permitted by applicable law, orcreate any derivative works based on the
      services, including any document, form or file (or any part thereof),
      orattempt to identify any source code, algorithm, method or technology or
      any derivative works of it contained in the platform;
    </p>
    <p>
      ·Send any unsolicited and unauthorized spam (such as spam comments on our
      social media services), advertising or promotional information, or any
      other commercial communications;
    </p>
    <p>
      ·Use our services for any commercial purpose or for the benefit of any
      third party, except as expressly permitted by these terms or by us from
      time to time, including any of the following activities:
    </p>
    <p>
      。Publish information about products or services provided by you or any
      company inwhich you have a direct or indirect interest;
    </p>
    <p>
      。Publish products or services that compete directly with products or
      services that you orany company in which you directly or indirectly own an
      interest compete with;
    </p>
    <p>
      。Make a posting (whether written by you or anyone else) in exchange for
      monetary orother benefits or compensation from any third party;
    </p>
    <p>
      。Publish information about the availability of products or shipping from
      third partysuppliers, whether or not such third parties compete with us;
    </p>
    <p>。Publish in other disingenuous ways.</p>
    <p>
      ·Submit, upload, transmit or display any content via our services that is
      or is deemed unreasonable by us (whether or not displayed publicly and
      whether or not displayed directly or indirectly to any other user)
    </p>
    <p>
      。Violate any law or regulation (or may violate any law or regulation when
      using in amanner permitted by these terms);
    </p>
    <p>。Cause loss or damage to any person or property;</p>
    <p>。Be fraudulent, false, misleading or deceptive;</p>
    <p>
      。Harm or exploit any person (adult or minor) in any way, including
      through bullying, harassment or threats of violence；
    </p>
    <p>
      。Hate, harass, abuse, racially or ethnically offend, defame, insult
      others (publicly orotherwise), threaten, profane, or otherwise make others
      repugnant;
    </p>
    <p>。Promote or encourage self-harm;</p>
    <p>
      。Infringe our rights or the rights of any third party, including any
      intellectual propertyrights, contractual rights, confidentiality or
      privacy rights;
    </p>
    <p>。Be pornographic, barefaced, violent or indecent or offensive;</p>
    <p>。Encourage or may encourage any of the above.</p>
    <p>
      ·Violate any applicable laws or regulations, including credit card fraud
      or bank account fraud;
    </p>
    <p>
      ·Engage in any illegal or potentially illegal (as determined by us)
      activity or transaction, including the sale of any illegal drugs or money
      laundering;
    </p>
    <p>
      ·Gamble, provide gambling information or induce others to gamble in any
      way;
    </p>
    <p>
      ·Use any of our intellectual property rights (including our trademark,
      brand name, logo, any of our proprietary information or any other page
      layout or design), or otherwise violate any of our intellectual property
      rights (including trying to undo) to design any application or software to
      access our services;
    </p>
    <p>
      ·Access any of our services, collect or process any content provided
      through our services, or send or redirect any communications through our
      services.Use automated bots, software, engines, crawlers, crawling tools,
      data mining tools or like or try to do any of the above, including
      artificially promoting any content using any automated means;
    </p>
    <p>
      ·Engage in any "framework," "mirror," or other technologies designed to
      simulate the appearance or functionality of our services;
    </p>
    <p>
      ·Interfere or attempt to interfere with the access of any user or any
      other party to our services;
    </p>
    <p>
      ·Deliberately distribute viruses, worms, Trojan horses, corrupted files or
      other malicious code or items;
    </p>
    <p>
      ·Use our services to share or publish the personally identifiable
      information of any other person without their express consent;
    </p>
    <p>
      ·Explore or test vulnerabilities in our services, our systems or other
      users' systems, or otherwise circumvent (or attempt to circumvent) any of
      their security functions;
    </p>
    <p>·Create multiple accounts for destructive or abusive purposes;</p>
    <p>
      ·Engage in any other activities that encourage any person or entity to
      violate these terms;
    </p>
    <p>
      ·Material that, in our sole discretion, is objectionable or restricts or
      prohibits the use of the services by any other person, or that may expose
      the platform, the services or its users to any kind of harm or liability;
    </p>
    <p>
      We reserve the right to remove or disable access to the content at any
      time, for any reason or without notice, in our sole discretion.Certain
      reasons why we may remove or disable access to content may include finding
      the content objectionable, violating these terms, or otherwise harming the
      services or our users.
    </p>
    <div>8.Platform Restrictions</div>
    <p>Youcannot, and cannot allow any other person to:</p>
    <p>
      ·Use the licensed Items in any manner or for any purpose that violates
      these terms or any applicable laws and regulations;
    </p>
    <p>
      ·Use the licensed items to gain unauthorized access to any system, account
      or data;
    </p>
    <p>·Sub-license, rent, lease, or sell the platform licenses;</p>
    <p>
      ·Directly or indirectly charge others for using or accessing the platform;
    </p>
    <p>
      ·Directly or indirectly suggest us support or accept any product, service
      or content (including any personal website);
    </p>
    <p>
      ·Transmit unauthorized communications, including spam, through the use of
      the licensed items;
    </p>
    <p>
      ·Remove, obscure, or modify any copyright, trademark, or other proprietary
      notices, marks, or instructions found in or on the Platform;
    </p>
    <p>·Distort the origin or ownership of licensed items;</p>
    <p>
      ·Copy, adapt, modify, translate or create derivative works from the
      licensed items, lend, rent, lease, performance, sub-license, make
      available to the public, broadcast, distribute, transmit, or otherwise use
      in whole or license portions of any licensed item in any manner expressly
      prohibited by these terms, or attempt to perform any of these items;
    </p>
    <p>
      ·Attempt to interfere or interfere with the platform, including
      manipulating its lawful operations;
    </p>
    <p>
      ·Use cheating, exploitation and automation software or any unauthorized
      third-party software designed to modify or interfere with the platform;
    </p>
    <p>
      ·Interfere with or overburden any computer or server that provides or
      supports the platform or other users' use of the platform;
    </p>
    <p>
      ·Develop any plug-ins, external component compatibilities or interconnect
      elements or other technical interoperability platforms, except that we
      expressly allow you to do so through our software (in which case you may
      be subject to additional terms and conditions with you informing us of
      such software);
    </p>
    <p>
      ·Please note that the "platform" may have technical measures designed to
      prevent unapproved or unauthorized use of the "platform" or use of the
      "platform" in violation of these terms.You agree that we can use these
      measures and that you will not attempt to disable or circumvent them in
      any way.
    </p>
    <div>9.Compensation</div>
    <p>
      You agree to defend, indemnify and hold harmless all claims, liabilities,
      costs, damages, losses and expenses (including but not limited to
      attorney's fees and expenses) for us, our parents, subsidiaries and
      affiliates and their respective officers, directors, employees, agents and
      consultants.These claims, losses and expenses (including but not limited
      to attorney's fees and expenses) are due to any breach of these terms by
      you (or any user of any service account), including but not limited to any
      breach of your obligations, agents and warranties.
    </p>
    <div>10.Disclaimer of Warranties</div>
    <p>
      No content in these terms affects legal rights that you cannot agree to
      change or waive as agreed in the contract, and you shall always use them
      as a consumer.
    </p>
    <p>
      The services are provided "as they are".We make no warranties or
      representations regarding these contents.In particular, we do not
      represent or guarantee that:
    </p>
    <p>·Your use of the services will meet your requirements;</p>
    <p>
      ·Your use of the services will be uninterrupted, timely, secure or error
      free;
    </p>
    <p>
      ·Any information you receive as a result of your use of the services is
      accurate or reliable;
    </p>
    <p>
      ·Defects in the operation or functionality of any software provided to you
      as part of the services will be corrected.
    </p>
    <p>
      No conditions, warranties or other terms (including any implied terms
      relating to satisfactory quality, fitness for purpose or compliance with
      description) shall apply to the service except as expressly set out in the
      terms.We may change, suspend, withdraw or limit the availability of all or
      any part of our platform at any time without notice for business and
      operation purposes.
    </p>
    <div>11.Scope of Liability</div>
    <p>
      No content in these terms excludes or limits our liability for damages
      that may not be legally excluded or limited by applicable law.This
      includes death or personal injury and fraud or fraudulent representations
      due to our negligence or the negligence of employees, agents or
      subcontractors.
    </p>
    <p>
      In accordance with the above terms, we do not assume any liability to you
      for the following:
    </p>
    <p>
      (I) Loss of profits (whether directly or indirectly);(II) Loss of
      goodwill;(III) Loss of opportunities;(IV) Loss of data that you suffer; or
      (V) Indirect or consequential loss that you may suffer.Any other losses
      you pay to Haba during the past 12 months will be limited to the amount
      you pay.
    </p>
    <p>Any loss or damage you may suffer as a result of the following:</p>
    <p>
      ·Any changes we may make to the services, or permanent or temporary
      discontinuation (or any functionality in the services) due to the
      provision of the services;
    </p>
    <p>
      ·Deletion, corruption, or storage failure of any content and other
      communication data maintained or transmitted using the services;
    </p>
    <p>·Your failure to provide us with accurate account information;</p>
    <p>
      ·Your failure to keep your password or account details secure and
      confidential.
    </p>
    <p>
      Please note that our platform is for home and private use only.You agree
      not to use our platform for any business or commercial purposes, and we
      shall not be liable for any loss of profit, loss of business, loss of
      goodwill or business reputation, business interruption or loss of business
      opportunities.
    </p>
    <p>
      If defective digital content provided by us damages yourdeviceor digital
      content due to our failure to use reasonable measures and functions, we
      will repair the damage or pay you compensation.However, we shall not be
      held liable for your failure to properly follow the installation
      instructions or recommendations to comply with minimum system
      requirements, and you may avoid following our recommendations and applying
      updates, and these limitations on our liability to you shall apply
      regardless of whether we have been informed or should have been aware of
      the possibility of any such loss.
    </p>
    <p>
      You are responsible for any mobile charges that may apply to your use of
      our services, including text message and data charges.If you are unsure of
      these charge standards, please consult the service provider before using
      the services.
    </p>
    <p>
      To the fullest extent permitted by law, you irrevocably release us and our
      affiliates from all known and unknown claims, demands and damages (actual
      and consequential) due to any dispute arising out of your use of the
      services with any third party, including any carrier, copyright owner or
      other user directly between you and such third party.
    </p>


    <div>12.Top-ups and Refunds</div>
      <p>Coins, diamonds, gifts and similar items (“Virtual Items”) are digital content for use only in the Service and are non-refundable once delivered, except where mandatory law requires otherwise.</p>
  <p>You agree not to abuse refunds or chargebacks (for example, requesting a refund after using Virtual Items). Such abuse is a material breach of these Terms.</p>
  <p>If we detect refund abuse or fraud, we may suspend or permanently ban your Account and forfeit remaining Virtual Items, with or without notice. Reinstatement is at our sole discretion and may require reimbursement of reversed amounts.</p>
  <p>Nothing in this Section limits any mandatory consumer rights you may have under the laws of your jurisdiction.</p>
  <p>These Terms shall be governed by and construed in accordance with the laws of the Hong Kong Special Administrative Region. In the event of any inconsistency between the English version and the Chinese version, the Chinese version shall prevail.</p>
    <p>Haba may offer promotional campaigns from time to time, including promotions where users receive additional Coins, Gifts, or other Virtual Items as promotional rewards when purchasing Diamonds.</p>
<p>The content, quantity, and type of promotional rewards included in each Diamond purchase offer will be displayed to users before completing the transaction. Promotional rewards are subject to the applicable campaign rules and may vary depending on factors such as campaign duration, user eligibility, purchase conditions, or other requirements.</p>
<p>All Virtual Items, including Diamonds and any Coins, Gifts, or other Virtual Items obtained through promotional campaigns, are digital content provided solely for use within the Haba Service. Virtual Items have no real-world monetary value, cannot be exchanged for cash, redeemed for real-world goods or services, sold, transferred, or transferred outside the Haba Service.</p>


    <div>13.Updates and Changes to Software and Services</div>
    <p>
      We may, in our sole discretion, distribute corrections, updates, upgrades
      and new versions of the “software" and/or "services" (collectively, the
      "Updates").You agree to receive and allow us to provide updates to your
      device, and you acknowledge that if you do not accept and install updates,
      the software and/or services may no longer operate with the full
      functionality or performance described in the specification, or fail
      tooperate.
    </p>
    <p>
      We reserve the right, at our discretion, to change or restrict the
      functionality and performance of the software and/or services, including
      withdrawing support or access to the software and/or services, and to
      prevent the use of any software and/or services with all available updates
      that have not been installed.
    </p>
    <p>
      These updates can be automated or manual.Please note that if you have not
      installed an upgrade or a new version, the software and/or services may
      not operate properly or fail to operate.We do not warrant that any updates
      will be provided to any of our software or services or that such updates
      will continue to support your device or system.
    </p>
    <div>14.Payments, Fees and Charges</div>
    <p>
      You may make payments to us or other third parties from time to time in
      connection with the "platform".You agree that, in addition to any other
      relevant provisionsof these terms, you will comply with all terms and
      conditions of the relevant payment service (whether the payment service
      provider is us or a third party).We are not liable for any transactions
      processed by third parties or any payments made to third parties, whether
      or not in connection with the relevant licensed items.You agree to bear
      all costs and taxes associated with the platform and that all prices and
      availabilityof the platform may change from time to time.
    </p>
    <p>
      Unless otherwise provided in these terms of the services or required by
      applicable law in your jurisdiction, no virtual goods and virtual currency
      shall be refundable after purchase (whether used or unused) under any
      circumstances.
    </p>
    <p>
      Please note that telecom charges and other charges may be incurred when
      you are using the "platform".You are responsible for all such fees,
      charges and expenses.
    </p>
    <div>15.Intellectual Property</div>
    <p>
      All intellectual properties (including any future updates, upgrades and
      new versions) of the platform and our other services and software will
      continue to belong to us and our licensors.You have no right to use our
      intellectual properties unless expressly provided in these terms.In
      particular, you have no right to use our trademarks or product names,
      logos, domain names or other unique brand features without our prior
      written consent.Any comments or suggestions you may make about our
      services are entirely voluntary and we will be free to use them at our
      discretion without payment or other obligations to you.
    </p>
    <p>
      We respect allintellectual properties and ask you to do so.As a condition
      of accessing and using the services, you agree not to use the services to
      infringe any intellectual properties, for example, not to upload any
      content owned by any other person to the platform.We reserve the right,
      with or without notice, at any time in our sole discretion to block access
      and/or terminate the account of any user who infringes or is accused of
      infringing any copyright or other intellectual properties.
    </p>
    <div>16.Third-party Software, Content and Services</div>
    <p>
      We are not responsible for, and do not provide support or guarantee for
      the legality, accuracy or reliability of any content submitted,
      transmitted or displayed or linked to by our software, services or our
      advertisers (including your content or other content provided by other
      users).You acknowledge and agree that, by using our software or services,
      you may be exposed to content that is inaccurate, misleading, defamatory,
      offensive or illegal.Any reliance on or use of our software or services or
      any content accessible from our software or services is at your own
      risk.Your use of our software or services does not entitles you to any
      rights to access to content in connection with your use of our software or
      services.
    </p>
    <p>
      We also do not guarantee the quality, reliability or suitability of any
      third-party services provided, advertised or linked to through our
      software or services, and we assume no responsibility for your use of or
      relationship with any such third-party services.If you access third-party
      services through our software or services, you must comply with any terms
      and conditions that apply to those services.
    </p>
    <p>
      We may review (but do not undertake to review) content or third-party
      services provided through our software or services to determine whether
      they comply with our policies, applicable laws and regulations, or whether
      they are objectionable.We may remove or refuse to provide or link to
      certain content or third-party services if they infringe intellectual
      properties, are obscene, defamatory or abusive, infringe any rights or
      pose any risk to the security or performance of our software or services.
    </p>
    <p>
      We may from time to time provide you with third-party content and services
      through our software or services.Such content and services are subject to
      other terms, including those of the relevant third parties that originally
      generated such content and services.In such event, you agree to comply
      with any other terms and conditions notified to you in respect of such
      third-party content and services.
    </p>
    <p>
      In addition, please note that we do not assume any responsibility, nor do
      we accept, support or guarantee the quality, reliability or suitability of
      any content, software, plug-ins, tools or data provided by third parties
      in connection with the licensed use.Any reliance on or use of such
      content, software, tools, plug-ins or data is at your own risk.You must
      comply with any other terms applicable to any third-party content,
      software, tools, plug-ins and data.
    </p>
    <div>17.Use Your Device through Our Software and Services</div>
    <p>
      To better provide you with our software and services, we may ask to access
      and/or use your related devices (e.g., mobile phones, tablets) to access
      the software and/or services- for example, we may need to use your
      device's processor and storage to complete related software installation,
      or we may need to access your contact list to provide certain interactive
      functions in our application.You agree to allow us to access and use your
      device. Please refer to thePrivacy Policyfor detailed descriptions of
      these contents. You may also use the guidelines in the Privacy Policy to
      restrict our use of certain functions on your device.
    </p>
    <p>
      We will provide further information about how a particular item's software
      or a particular service can be used and accessed by you in the relevant
      software or service or in other ways to access your device (for example,
      stored as part of the installation process of the relevant service through
      the relevant installer).Please understand that we may not be able to
      provide you with our relevant software or services if you have not
      provided us with authorization to use or access your relevant devices.
    </p>
    <p>
      Any personal information we use or access on your device (as defined in
      the Privacy Policy) will be treated in accordance with these terms
      (including our Privacy Policy).
    </p>
    <div>18.Termination</div>
    <p>
      We reserve the right to temporarily or permanently suspend or terminate
      your user account or restrict your access to some or all of the services
      with or without notice to you, including:
    </p>
    <p>
      ·We reasonably believe that you have violated these terms, or we
      reasonably believe on objective grounds that you will violate these terms,
      including any combined agreements, policies or guidelines and applicable
      laws or regulations;
    </p>
    <p>
      ·Your activities on your account, in our sole discretion,may cause damage
      to us or our services, or infringe any third-party rights (including
      intellectual properties);
    </p>
    <p>
      ·Responding to requests from law enforcement or other government agencies
      under effective legal procedures;
    </p>
    <p>·Unexpected technical or security issues;</p>
    <p>·Your account is inactive for a long time.</p>
    <p>
      If we closepermanently or terminate your user account, we will inform you
      in advance, so that you have the time to access and save your information
      and content, unless we have reason to believe that your continued access
      to your account will harm us or our services, orviolate the requirements
      of law enforcement or other government agencies (applicable laws or
      regulations or third-party rights).
    </p>
    <p>
      Depending on any legal rights you may have, if your account is temporarily
      or permanently suspended or terminated, access to your user name,
      password, and any relevant information or content associated with your
      account may be suspended or terminated.Since we do not guarantee that your
      content will be permanently available, you should back up any content you
      value.
    </p>
    <p>
      If you no longer want to use our services, you can contact us at
      report@habagogo.com and we will provide you with further assistance and
      guide you in deleting your account.Please note that once you choose to
      delete your account, you will not be able to reactivate the account or
      retrieve any content or information that you have added.
    </p>
    <div>19.Your Legal Rights</div>
    <p>
      No content in these terms shall supersede your obligatoryrights under any
      laws and regulations, and your obligatoryrights will apply in the event of
      any inconsistency with these terms.
    </p>
    <div>20.General</div>
    <p>
      You agree that no claim shall be made against us for any statement not
      expressly provided for in these terms.The invalidity of any provision (or
      part of any provision) of these terms does not affect the validity or
      enforceability of any other provisions (or the remainder of such
      provision).If a court finds that we are unable to enforce any part of
      these terms as drafted, we may, to the extent that applicable laws and
      regulations are enforceable, replace such terms with similar terms without
      changing the remaining provisions of these terms.No delay in enforcing any
      provision of these terms shall be construed as a waiver of any right under
      such provision.Any rights and obligations under these terms shall, by
      their nature, continue in force and effect, including but not limited to
      any obligation of the parties with respect to their liability or
      compensation (if any), which shall survive the termination or expiration
      of these terms.
    </p>
    <p>
      No person other than you and us (subject to any applicable laws and
      regulations) has the right to enforce these terms against anyone, and you
      may not delegate, assign or transfer these terms or any rights or
      obligations under these terms without our prior consent.We are free to
      assign, transfer or subcontract these terms or all or part of our rights
      and obligations under these terms without your prior consent or notice.You
      acknowledge and agree that in no event shall our partners or affiliates
      assume any liability under these terms.
    </p>
    <div>21.Applicable Law and Dispute Resolution</div>
      <p>These Terms and any disputes, claims, or controversies arising out of or relating to these Terms shall be governed by and construed in accordance with the laws of the Hong Kong Special Administrative Region of the People's Republic of China.</p>

    <p>Any dispute arising out of or relating to these Terms, including but not limited to matters concerning the existence, validity, interpretation, performance, breach, termination, or enforceability of these Terms, shall first be resolved through friendly consultation between the parties. If the dispute cannot be resolved through consultation, either party may submit the dispute to the Hong Kong International Arbitration Centre ("HKIAC") for arbitration in accordance with the HKIAC Arbitration Rules in effect at the time, and the arbitral tribunal's award shall be final and binding upon the parties.</p>

<p>The seat of arbitration shall be the Hong Kong Special Administrative Region of the People's Republic of China. The arbitral tribunal shall consist of one (1) arbitrator. The language of arbitration shall be Chinese.</p>



    <div>Contact Us</div>
    <p>You can contact us at report@habagogo.com or write to us.</p>

    <div>Supplementary Terms for App Stores</div>
    <p>
      To the extent permitted by applicable law, the following supplementary
      terms shall apply:
    </p>
    <p>
      By accessing the platform through a device manufactured by Apple Inc.
      ("Apple"), you expressly acknowledge and agree that:
    </p>
    <p>·Apple is not a party to these terms with you.</p>
    <p>
      ·The license granted to you pursuant to this Agreement is limited to the
      personal, limited, non-exclusive and non-transferable rights,so that the
      installation of the platform on Apple authorized Apple devices that you
      own or control for personal and non-commercial use is subject to the rules
      of use set forth in the service terms of Apple App Store.
    </p>
    <p>
      ·Apple is not responsible for the platform or its content, nor is it
      liable for any maintenance or support services related to the platform.
    </p>
    <p>
      ·If the platform fails to comply with any of the applicable warranties,
      you may notify Apple and Apple will refund you the purchase price of the
      platform (if any).To the maximum extent permitted by applicable law, Apple
      assumes no other warranty obligations with respect to the platform.
    </p>
    <p>
      ·Apple is not responsible for resolving any claims made by you or third
      parties concerning the platform or your ownership or use of the
      platform,including but not limited to (a) product liability claims; (b)
      any claim that the platform does not comply with the requirements of any
      applicable law or regulation; (c) claims arising under consumer protection
      or similar laws and regulations.
    </p>
    <p>
      ·If any third party claims that the platform or your ownership and use of
      the platform violates such third party's intellectual property rights,
      Apple shall not be responsible for investigating, defending, settling or
      removing claims for such infringement of intellectual property rights.
    </p>
    <p>
      ·You represent and warrant that (a) you are not in a country embargoed by
      the US Government or designated by the US Government as a state sponsor of
      terrorism;(b) you are not on any list of prohibited or restricted parties
      of the US Government.
    </p>
    <p>
      ·Apple and its subsidiaries are third-party beneficiaries of these terms,
      and once you accept the terms and conditions of these terms, Apple will
      have the right (and will be deemed to have accepted the right) to enforce
      these terms against you as a third-party beneficiary.
    </p>
    <p>
      ·Haba explicitly authorizes multiple users to use the platform through
      family sharing or any similar functions provided by Apple.
    </p>
    <div>Supplementary Terms for Google Play</div>
    <p>
      By downloading the platform from Google Play (or its successor) operated
      by Google Inc. or one of its affiliates ("Google"), you expressly
      acknowledge and agree that:
    </p>
    <p>
      ·(a)Google Play Terms of ServiceandGoogle Play Business and Planning
      Policyor all other terms that Google designates as default end user
      license terms for Google Play (collectively, the "Google Play Terms"), and
      (b) other terms and conditions in these terms shall apply to your use of
      the platform downloaded from Google Play.
    </p>
    <p>
      ·You hereby confirm that Google has no responsibility or obligation for
      the compliance or non-compliance of Haba or you (or any other user)
      under these terms or Google Play Terms.
    </p>
  </div>
</template>  

<script>
export default {
  name: "terms",
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.root{
    text-align: left;
    margin: 10px;
}
header{
    
    padding: 10px;
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    margin-bottom: 10px;
    font-weight: 900;
}
div {
    font-size: 25px;
    font-weight: 900;
}
b{
    font-size: 20px;
    font-weight: 900;
}

p{
    font-size: 16px;
    font-weight: 500;
}
table {
    border-collapse: collapse;
}

th, td {
    border: 1px solid black;
    padding: 8px;
    text-align: left;
}
td ,li{
    font-size: 16px;
}
a{
    color: blue;
}</style>
